import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif",
  },
});

export default theme;

